import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'cdw-ae-spog-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class SpogFooterComponent {
  readonly isProduction = environment.production ?? false;
  readonly revision = environment.revision || 'unknown';
  readonly version = environment.version || '0.0.0';
  readonly privacyUrl = environment.urls.legal.privacyNotice;

  /**
   * ISO license-expiry date for the left-hand "License for Gopher for Chrome Premium expires on …"
   * line. Two sources, because the two contexts have different data available:
   * the onboarding wizard passes `progress().licenseExpiry` from GET
   * /onboarding/progress (EDUS-2681), and the internal app layout passes
   * `context.expiry` off the login resolution (EDUS-2810). Both ultimately
   * read the same `LicenseAccess.expiry`.
   *
   * Null hides the line rather than showing a placeholder date — which also
   * covers the moment before the app's login resolution lands.
   */
  @Input() licenseExpiry?: string | null;
}
